(function () {
  if (!document.querySelector(".gads-page")) return;

  document.documentElement.classList.add("gads-hide-smile");

  const sticky = document.querySelector("[data-gads-sticky]");
  const offer = document.querySelector("#gads-offer");
  const booking = document.querySelector("#gads-booking");

  function updateSticky() {
    if (!sticky) return;
    const offerRect = offer ? offer.getBoundingClientRect() : null;
    const nearOffer =
      offerRect && offerRect.top < window.innerHeight * 0.35 && offerRect.bottom > 80;
    const bookingRect = booking ? booking.getBoundingClientRect() : null;
    const nearBooking =
      bookingRect && bookingRect.top < window.innerHeight && bookingRect.bottom > 0;
    sticky.classList.toggle("is-visible", !nearOffer && !nearBooking);
  }

  window.addEventListener("scroll", updateSticky, { passive: true });
  window.addEventListener("resize", updateSticky);
  updateSticky();

  document.querySelectorAll("[data-gads-copy]").forEach((button) => {
    button.addEventListener("click", async () => {
      const code = button.getAttribute("data-gads-copy");
      if (!code) return;
      try {
        await navigator.clipboard.writeText(code);
        const original = button.textContent;
        button.textContent = button.getAttribute("data-copied-label") || "OK";
        setTimeout(() => {
          button.textContent = original;
        }, 1600);
      } catch (e) {
        console.warn(e);
      }
    });
  });


  initGalleries();

  function initGalleries() {
    document.querySelectorAll("[data-gads-gallery]").forEach((root) => {
      const track = root.querySelector("[data-gads-gallery-track]");
      const slides = [...root.querySelectorAll("[data-gads-gallery-slide]")];
      const dotsWrap = root.querySelector("[data-gads-gallery-dots]");
      const prev = root.querySelector("[data-gads-gallery-prev]");
      const next = root.querySelector("[data-gads-gallery-next]");
      if (!track || slides.length === 0) return;

      let index = 0;
      let timer = null;
      let startedAt = 0;
      let remaining = 0;
      const interval = Math.max(
        2000,
        parseInt(root.getAttribute("data-interval") || "3000", 10) || 3000
      );
      const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

      if (dotsWrap) {
        dotsWrap.innerHTML = slides
          .map(
            (_, i) =>
              `<button type="button" class="gads-gallery__dot" data-index="${i}" role="tab" aria-label="Foto ${i + 1}"></button>`
          )
          .join("");
      }
      const dots = [...root.querySelectorAll(".gads-gallery__dot")];

      function offsetFor(i) {
        const slide = slides[i];
        const viewport = root.querySelector(".gads-gallery__viewport");
        if (!slide || !viewport) return 0;
        const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
        return slideCenter - viewport.clientWidth / 2;
      }

      function clearTimer() {
        if (timer) {
          clearTimeout(timer);
          timer = null;
        }
      }

      function bumpDotProgress() {
        if (reduceMotion) return;
        root.classList.remove("is-paused");
        root.classList.remove("is-playing");
        void root.offsetWidth;
        root.classList.add("is-playing");
      }

      function scheduleNext(ms) {
        clearTimer();
        remaining = ms;
        startedAt = Date.now();
        timer = window.setTimeout(() => {
          timer = null;
          goTo(index + 1, { mode: "auto" });
        }, ms);
      }

      function goTo(nextIndex, { mode = "restart" } = {}) {
        index = (nextIndex + slides.length) % slides.length;
        track.style.transform = `translate3d(${-offsetFor(index)}px, 0, 0)`;
        slides.forEach((slide, i) => slide.classList.toggle("is-active", i === index));
        dots.forEach((dot, i) => {
          dot.classList.toggle("is-active", i === index);
          dot.setAttribute("aria-selected", i === index ? "true" : "false");
        });
        if (mode === "restart") restartAutoplay();
        else if (mode === "auto") {
          remaining = interval;
          bumpDotProgress();
          scheduleNext(interval);
        }
      }

      function pauseAutoplay() {
        if (reduceMotion || slides.length < 2) return;
        if (timer) {
          remaining = Math.max(0, remaining - (Date.now() - startedAt));
          clearTimer();
        }
        root.classList.add("is-paused");
      }

      function resumeAutoplay() {
        if (reduceMotion || slides.length < 2) return;
        root.classList.remove("is-paused");
        if (!root.classList.contains("is-playing")) {
          restartAutoplay();
          return;
        }
        scheduleNext(remaining > 0 ? remaining : interval);
      }

      function restartAutoplay() {
        clearTimer();
        root.classList.remove("is-paused");
        if (reduceMotion || slides.length < 2) {
          root.classList.remove("is-playing");
          return;
        }
        remaining = interval;
        bumpDotProgress();
        scheduleNext(interval);
      }

      prev?.addEventListener("click", () => goTo(index - 1));
      next?.addEventListener("click", () => goTo(index + 1));
      dots.forEach((dot) => {
        dot.addEventListener("click", () => goTo(Number(dot.dataset.index)));
      });

      root.addEventListener("mouseenter", pauseAutoplay);
      root.addEventListener("mouseleave", resumeAutoplay);
      root.addEventListener("focusin", pauseAutoplay);
      root.addEventListener("focusout", (e) => {
        if (!root.contains(e.relatedTarget)) resumeAutoplay();
      });

      let touchX = null;
      root.addEventListener(
        "touchstart",
        (e) => {
          touchX = e.changedTouches[0].clientX;
          pauseAutoplay();
        },
        { passive: true }
      );
      root.addEventListener(
        "touchend",
        (e) => {
          if (touchX == null) return;
          const dx = e.changedTouches[0].clientX - touchX;
          touchX = null;
          if (Math.abs(dx) > 40) goTo(index + (dx < 0 ? 1 : -1));
          else resumeAutoplay();
        },
        { passive: true }
      );

      window.addEventListener("resize", () => goTo(index, { mode: "layout" }));
      goTo(0);
    });
  }
})();
